import * as React from "react";
import classnames from "classnames";
import { LoaderScreen } from "@grandvisionhq/common";
import { ConfiguratorStepTitleAndDescription } from "@grandvisionhq/configurator";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { RxStepWrapper } from "../../../../RxStepWrapper/steps/components/RxStepWrapper/RxStepWrapper.js";
import DesktopStepLayout from "../../../../DesktopStepLayout/steps/components/DesktopStepLayout/DesktopStepLayout.js";
/* empty css                    */
const StepWithAlerts = ({
  alertLabel,
  children,
  className,
  errorMessage,
  errorMessageId,
  isFailed,
  isLoading,
  descriptionSuffix
}) => {
  const { getLabel } = useIntl();
  const alertRef = React.useRef(null);
  React.useEffect(() => {
    if ("scrollBehavior" in document.documentElement.style) {
      alertRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      alertRef.current?.scrollIntoView();
    }
  }, [errorMessage]);
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(LoaderScreen, null);
  }
  if (isFailed) {
    return /* @__PURE__ */ React.createElement(
      Alert,
      {
        variant: "error",
        title: getLabel("products.glasses.configurator.error"),
        className: "alert-m-default step-with-alerts__alert"
      }
    );
  }
  return /* @__PURE__ */ React.createElement(RxStepWrapper, { className: classnames("step-with-alerts", className) }, /* @__PURE__ */ React.createElement(DesktopStepLayout, null, /* @__PURE__ */ React.createElement("div", { className: "step-with-alerts__wrapper" }, /* @__PURE__ */ React.createElement(
    ConfiguratorStepTitleAndDescription,
    {
      descriptionSuffix,
      textAlignment: "left"
    }
  ), alertLabel && /* @__PURE__ */ React.createElement(
    Alert,
    {
      variant: "info",
      title: alertLabel,
      className: "alert-m-default step-with-alerts__alert"
    }
  ), errorMessage && /* @__PURE__ */ React.createElement("div", { ref: alertRef }, /* @__PURE__ */ React.createElement(
    Alert,
    {
      id: errorMessageId,
      variant: "error",
      title: errorMessage,
      className: "alert-m-default step-with-alerts__alert",
      notifyScreenReader: true
    }
  )), children)));
};
export {
  StepWithAlerts
};
//# sourceMappingURL=StepWithAlerts.js.map
